export default class LanguageBar {
    constructor(el){
        this.el = el;
        if(this.el){
            this.close = el.querySelector('.closeLanguageSelector');
            this.bind();
            this.show();
        }
    }

    bind() {
        this.close.addEventListener('click', (e) => this.hide(e));
    }

    show() {
        if(!window.localStorage.languageBar){
            this.el.classList.add('animate');
            this.el.style.height = `${this.el.scrollHeight}px`;
        }
    }

    hide(e) {
        e.preventDefault();
        this.el.style.height = '0';
    }
    save() {
        window.localStorage.languageBar = 'seen';
    }
}


if (document.querySelector('header.languageSelector')) {
    const languageBar = new LanguageBar(document.querySelector('header.languageSelector'));
}
